/**
 * @generated SignedSource<<dc90cd2e766d44c78acc8917c9238303>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteProjectSubmissionInput = {
  clientMutationId?: string | null | undefined;
  projectSubmissionId?: string | null | undefined;
  projectSubmissionRawId?: number | null | undefined;
};
export type ProjectSubmissionsField_DeleteProjectSubmissionMutation$variables = {
  input: DeleteProjectSubmissionInput;
};
export type ProjectSubmissionsField_DeleteProjectSubmissionMutation$data = {
  readonly deleteProjectSubmission: {
    readonly projectSubmission: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectSubmissionsField_DeleteProjectSubmissionMutation = {
  response: ProjectSubmissionsField_DeleteProjectSubmissionMutation$data;
  variables: ProjectSubmissionsField_DeleteProjectSubmissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSubmissionsField_DeleteProjectSubmissionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteProjectSubmissionPayload",
        "kind": "LinkedField",
        "name": "deleteProjectSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSubmission",
            "kind": "LinkedField",
            "name": "projectSubmission",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectSubmissionsField_DeleteProjectSubmissionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteProjectSubmissionPayload",
        "kind": "LinkedField",
        "name": "deleteProjectSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSubmission",
            "kind": "LinkedField",
            "name": "projectSubmission",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "287d489c1ecd727fc1d711b0b92bbdd1",
    "id": null,
    "metadata": {},
    "name": "ProjectSubmissionsField_DeleteProjectSubmissionMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectSubmissionsField_DeleteProjectSubmissionMutation(\n  $input: DeleteProjectSubmissionInput!\n) {\n  deleteProjectSubmission(input: $input) {\n    projectSubmission {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7668ca689ddc8d4c14f792f0b3f9bf94";

export default node;
